import * as React from 'react';
import {
    List,
    EditButton,
    Datagrid,
    TextField,
    NumberField,
    useRecordContext,
    useNotify,
    useDataProvider,
    DataProviderContext,
    useRefresh,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import ProductTemplatesLinkField from './ProductTemplateLinkField';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import useIsPermission from '../../hooks/useIsPermission';
import { createCustomGoDataProvider, goApi } from '../../services';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from '@mui/material';
import StatusTags from '../../common/StatusTags';
import { apiRoutes } from '../../services/apiRoutes';

const CategoryList = () => {
    const { isWritable, isDeletable, isUpdatable } = useIsPermission('ECOM_CATEGORIES');

    const InlineDeleteButton = () => {
        const record = useRecordContext<any>();
        const notify = useNotify();
        const refresh = useRefresh();

        if (!record) return null;

        const handleDelete = async () => {
            try {
                await goApi.delete(apiRoutes.ECOM_CATEGORIES + `/${record.id}`);
                notify('Category deleted successfully', { type: 'success' });
                refresh();
            } catch (error: any) {
                notify(error?.message || 'Delete failed', { type: 'error' });
            }
        };

        return (
            <Button color="error" startIcon={<DeleteIcon />} onClick={handleDelete} size="small">
                Delete
            </Button>
        );
    };
    const baseDataProvider = useDataProvider();
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'ecom_categories', apiEndpoint: '/ecom/categories' },
            ]),
        [baseDataProvider],
    );
    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <List
                actions={
                    <PermissionBasedActions
                        isWritable={isWritable}
                        pagination={false}
                        exporter={false}
                    />
                }
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source="name" />
                    <TextField source="slug" />
                    <StatusTags source="status" />
                    <NumberField source="displayOrder" />
                    <ProductTemplatesLinkField />
                    <FormattedDateTimeField source="createdAt" sortable={false} />
                    {isDeletable && <InlineDeleteButton />}
                    {isUpdatable && <EditButton />}
                </Datagrid>
            </List>
        </DataProviderContext.Provider>
    );
};
export default CategoryList;
